/* eslint-disable @typescript-eslint/init-declarations */
/*
* Natural Sort algorithm for Javascript - Version 0.8.1 - Released under MIT license
* Author: Jim Palmer (based on chunking idea from Dave Koelle)
*/
const re = /(^([+-]?\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?(?=\D|\s|$))|^0x[\dA-Fa-f]+$|\d+)/g
const sre = /^\s+$/g
const unicodere = /[^\x00-\x80]/ // eslint-disable-line no-control-regex

// trim pre-post whitespace
const snre = /\s+/g
const hre = /^0x[\da-f]+$/i
const ore = /^0/

function i (s) {
  return ('' + s).replace(sre, '')
}

function prepare (a) {
  const x = i(a)
  const xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0')
  // eslint-disable-next-line @typescript-eslint/no-extra-parens
  const xD = parseInt(hre.exec(x)?.toString() ?? '0', 16)
  return { a, xN, xD }
}

function normChunk (s, l) {
  // normalize spaces; find floats not starting with '0', string or 0 if not defined (Clint Priest)
  // eslint-disable-next-line no-mixed-operators
  return (!s.match(ore) || l === 1) && parseFloat(s) || s.replace(snre, ' ').replace(sre, '') || 0
}

export function naturalCompare (x: any, y: any, cache: Record<string, any>): number {
  cache[x] ??= prepare(x)
  cache[y] ??= prepare(y)
  const a = cache[x]
  const b = cache[y]

  // convert all to strings strip whitespace
  const xN = a.xN
  const xD = a.xD
  const yN = b.xN
  const yD = b.xD

  let oFxNcL
  let oFyNcL
  // first try and sort Hex codes
  if (yD) {
    if (xD < yD) {
      return -1
    } else if (xD > yD) {
      return 1
    }
  }
  // natural sorting through split numeric strings and default strings
  for (let cLoc = 0, xNl = xN.length, yNl = yN.length, numS = Math.max(xNl, yNl); cLoc < numS; cLoc++) {
    oFxNcL = normChunk(xN[cLoc] || '', xNl)
    oFyNcL = normChunk(yN[cLoc] || '', yNl)
    // handle numeric vs string comparison - number < string - (Kyle Adams)
    if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
      return isNaN(oFxNcL) ? 1 : -1
    }
    // if unicode use locale comparison
    if (unicodere.test(oFxNcL + oFyNcL) && oFxNcL.localeCompare) { // eslint-disable-line
      const comp = oFxNcL.localeCompare(oFyNcL)
      return comp / Math.abs(comp)
    }
    if (oFxNcL < oFyNcL) {
      return -1
    } else if (oFxNcL > oFyNcL) {
      return 1
    }
  }

  return 0
}
